var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDropdownIcon = function SvgDropdownIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52649 9.97003C7.736 11.168 5.97828 11.168 5.18779 9.97003L0.985644 3.60148C0.108261 2.27177 1.0619 0.5 2.655 0.5L11.0593 0.5C12.6524 0.5 13.606 2.27177 12.7286 3.60149L8.52649 9.97003Z",
    fill: "#94989E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropdownIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNTI2NDkgOS45NzAwM0M3LjczNiAxMS4xNjggNS45NzgyOCAxMS4xNjggNS4xODc3OSA5Ljk3MDAzTDAuOTg1NjQ0IDMuNjAxNDhDMC4xMDgyNjEgMi4yNzE3NyAxLjA2MTkgMC41IDIuNjU1IDAuNUwxMS4wNTkzIDAuNUMxMi42NTI0IDAuNSAxMy42MDYgMi4yNzE3NyAxMi43Mjg2IDMuNjAxNDlMOC41MjY0OSA5Ljk3MDAzWiIgZmlsbD0iIzk0OTg5RSIvPgo8L3N2Zz4K";